import AppBridge from './bridge'
import { isJsonString } from './is'
import UnityBridge from './unityBridge'
import { isUnityUA, isAndroidUA, getUaDataRegex, extractJsonDataByProtocols } from './uaConfig'

export interface UnityBridgeUserInfoType {
  uid: number
  nickname: string
  pf: number
  version: string
  imei: string
}

export interface UnityCommonHeadersType {
  uid: number // 用户uid
  version: string // APP版本(1.47.1)
  pf: number // 平台类型 1:android; 2:ios; 3 web
  deviceId?: string // 设备ID（业务侧自定义生成规则）
  model?: string // 手机型号
  idfa?: string // 广告标示符 IDFA
  uuid?: string // 客户端生成的uuid标识符
  apil?: string // API Level
  aid?: string // 安卓ID
  pkgId?: string // 包id，只要包不同，pkg_id就不同，一个大区里面可能有不止一个包
  mktRegion?: string // 市场开放的大区。sea=东南亚，me=中东
  nlid?: string // 新言设备ID
}

const userAgent = navigator.userAgent
// const userAgent = 'weelife-unity,language:zh-hans,Android/null,weelife-data/{"pf":32,"version":"0.1","nickname":"{{{}}}},s,},","imei":"","uid":"293443"},weelife-common-headers/{"uid":"293443","deviceId":"5031F9B60352318B7A0932B383D9697AB","version":"1.47.8","model":"Pixel_3","pf":3,"idfa":"ee9e3812-48d6-4cd4-83c9-3871e4e20cda","uuid":"b168aea4-58bc-4575-bd13-7254ea58fe30","apil":"30","aid":"f4dac5a9698cd5c8","pkgId":"weelife_sea_01","mktRegion":"sea","nlid":"HK2e50353d5e7f4fada64bc7318c8df929"}'
// 提取 JSON 数据的函数
// 找到 weelife-data/ 的起始位置：
// 用于找到 weelife-data/ 的起始位置。如果找不到，函数返回 null。
// 从该位置开始，找到匹配的花括号：
// 使用 for 循环从 startIndex + key.length + 1 开始遍历字符串。
// 每当遇到 { 时，增加 braceCount；每当遇到 } 时，减少 braceCount。
// 当 braceCount 为 0 时，表示找到了完整的 JSON 对象。
// 提取并解析 JSON 字符串：
// 移除尾部的逗号。
// 使用 isJsonString 函数验证提取的字符串是否为有效的 JSON。
// 如果是有效的 JSON，使用 JSON.parse 解析，并返回解析后的对象。
export const extractJsonData = (userAgent: string, key: string): any => {
  const startIndex = userAgent.indexOf(`${key}/`)
  if (startIndex === -1) return null

  let braceCount = 0
  let jsonString = ''
  let inJson = false
  let quoteCount = 0 // 用于跟踪引号的数量

  for (let i = startIndex + key.length + 1; i < userAgent.length; i++) {
    const char = userAgent[i]

    if (char === '{' && quoteCount % 2 === 0) {
      braceCount++
      inJson = true
    } else if (char === '}' && quoteCount % 2 === 0) {
      braceCount--
    } else if (char === '"') {
      quoteCount++
    }

    if (inJson) {
      jsonString += char
    }

    if (inJson && braceCount === 0) {
      break
    }
  }

  // 移除尾部多余的字符
  const cleanJsonString = jsonString.replace(/,\s*$/, '')

  console.log(cleanJsonString)
  if (isJsonString(cleanJsonString)) {
    const data = JSON.parse(cleanJsonString)
    return data
  } else {
    console.error('提取的字符串不是有效的JSON:', cleanJsonString)
    return null
  }
}

export const removeNickname = (userAgent: string): string => {
  // 使用正则表达式匹配并替换 nickname 字段及其内容
  return userAgent.replace(/"nickname":"(.*?)",/, '')
}

export const regexNickname = (userAgent: string) => {
  const nicknameRegex = /"nickname":"([^"]*)",/
  const nicknameArr = userAgent.match(nicknameRegex) || []
  const nickname = nicknameArr.length > 1 ? nicknameArr[1] : ''
  return nickname
}

const HTMLEntityMap = {
  '&quot;': '"',
  '&lcub;': '{',
  '&rcub;': '}'
} as Record<string, string>

export const entityString = (str: string) => {
  return str.replace(/&quot;|&lcub;|&rcub;/g, (match) => HTMLEntityMap[match])
}

const getUid = (data: string) => {
  let uid = 0
  const uidRegex = /"uid":"([^"]*)"/
  const match = data.match(uidRegex)
  if (match) {
    uid = Number(match[1])
  }
  return uid
}

export const getWeelifeData = (userAgent: string) => {
  const weelifeArray = userAgent.match(getUaDataRegex()) || []
  const weelifeDataStr = weelifeArray[weelifeArray.length - 1]
  let weelifeData = null
  console.log('weelifeDataStr', userAgent)
  console.log('weelifeDataStr1', weelifeArray)
  try {
    weelifeData = JSON.parse(weelifeDataStr)
    weelifeData.nickname = entityString(weelifeData.nickname)
  } catch (error) {
    // TODO 兼容旧版本app nickname未特殊字符转译， 1.67版本优化
    const nickname = regexNickname(userAgent)
    const updatedUserAgent = removeNickname(userAgent)
    weelifeData = extractJsonDataByProtocols(updatedUserAgent, protocol => protocol.data)
    if (weelifeData) {
      weelifeData.nickname = nickname
    } else {
      const uid = getUid(updatedUserAgent)
      if (uid) {
        weelifeData = {
          uid: uid,
          nickname: nickname
        }
      }
    }
  }
  return weelifeData
}

export const getWeelifeDataByUnity = (data: string) => {
  const nickname = regexNickname(data)
  const removeNicknameData = removeNickname(data)
  let userInfo = null
  if (isJsonString(removeNicknameData)) {
    userInfo = JSON.parse(removeNicknameData)
    userInfo.nickname = nickname
  } else {
    console.error('提取的字符串不是有效的JSON:', removeNicknameData)
    // 保底获取uid
    const uid = getUid(data)
    if (uid) {
      userInfo = {
        uid: uid,
        nickname: nickname
      }
    }
  }
  return userInfo
}

// 获取unity提供的UserInfo(兼容安卓/iOS老版)
export const getUnityLocalUserInfo = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve: (data: UnityBridgeUserInfoType) => void) => {
    let initUserInfo = {
      uid: 0,
      nickname: '',
      pf: 3,
      version: '',
      imei: ''
    } as UnityBridgeUserInfoType
    // unity
    if (isUnityUA(userAgent)) {
      const weelifeData = getWeelifeData(userAgent)
      console.log('weelifeData1', weelifeData)
      if (weelifeData && JSON.stringify(weelifeData) !== '{}') {
        initUserInfo = weelifeData
        initUserInfo.uid = Number(weelifeData.uid) || 0
        initUserInfo.pf = 3
        console.log(initUserInfo)
        return resolve(initUserInfo)
      } else {
        await UnityBridge.callHandler('getUserInfo', (_, data) => {
          console.log(data)
          const userInfo = getWeelifeDataByUnity(data)
          if (userInfo && JSON.stringify(userInfo) !== '{}') {
            console.log('getUserInfo--', userInfo)
            initUserInfo = userInfo
            initUserInfo.uid = Number(userInfo.uid) || 0
            initUserInfo.pf = 3
            return resolve(initUserInfo)
          } else {
            return resolve(initUserInfo)
          }
        })
      }
    } else {
      const res = await AppBridge({
        method: 'getUid',
        module: '',
        data: {},
        callBack: true
      })
      if (res && JSON.parse(res).getUid) {
        initUserInfo.uid = JSON.parse(res).getUid.uid
      } else {
        initUserInfo.uid = 0
      }
      return resolve(initUserInfo)
    }
  })
}

// 获取unity提供的公用请求头部参数
export const getUnityCommonHeaders = () => {
  console.log('userAgent', userAgent)
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve: (data: UnityCommonHeadersType) => void) => {
    const currentUrl = window.location.href
    const params = new URLSearchParams(currentUrl.slice(currentUrl.indexOf('?')))
    console.log('uid', params.get('uid'))
    let initCommonHeaders: UnityCommonHeadersType = {
      uid: Number(params.get('uid')) || 0, // 用户uid
      deviceId: '', // 设备ID（业务侧自定义生成规则）
      version: '', // APP版本(1.47.1)
      model: '', // 手机型号
      pf: 3, // 平台类型 1:android; 2:ios; 3 web
      idfa: '', // 广告标示符 IDFA
      uuid: '', // 客户端生成的uuid标识符
      apil: '0', // API Level
      aid: '', // 安卓ID
      pkgId: '', // 包id，只要包不同，pkg_id就不同，一个大区里面可能有不止一个包
      mktRegion: '', // 市场开放的大区。sea=东南亚，me=中东
      nlid: '' // 新言设备ID
    }
    // unity
    if (isUnityUA(userAgent) || isAndroidUA(userAgent)) {
      const updatedUserAgent = removeNickname(userAgent)
      const weelifeCommonHeaders = extractJsonDataByProtocols(updatedUserAgent, protocol => protocol.commonHeaders)
      if (weelifeCommonHeaders && JSON.stringify(weelifeCommonHeaders) !== '{}') {
        initCommonHeaders = weelifeCommonHeaders
        initCommonHeaders.uid = Number(weelifeCommonHeaders.uid) || 0
        initCommonHeaders.pf = 3
        return resolve(initCommonHeaders)
      } else {
        await UnityBridge.callHandler('getCommonHeaders', (_, data) => {
          console.log('getCommonHeaders', data)
          if (data && JSON.parse(data)) {
            const userInfo = JSON.parse(data)
            if (userInfo) {
              initCommonHeaders = userInfo
              initCommonHeaders.uid = Number(userInfo.uid) || 0
              initCommonHeaders.pf = 3
              return resolve(initCommonHeaders)
            }
            return resolve(initCommonHeaders)
          } else {
            return resolve(initCommonHeaders)
          }
        })
      }
    } else {
      return resolve(initCommonHeaders)
    }
  })
}
